import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';
import { ViewBlacklistDto } from '../../../dto/viewblacklist/viewblacklistdto';

export interface ViewBlacklistResponse extends APIResponse
{
    getViewBlacklist() : ViewBlacklistDto;
}

export class ViewBlacklistResponseDtoImpl extends APIResponseDtoImpl implements ViewBlacklistResponse
{
    private viewBlacklist: ViewBlacklistDto;

    getViewBlacklist(): ViewBlacklistDto
    {
        return this.viewBlacklist;
    }
    setViewBlacklist(viewBlacklist: ViewBlacklistDto)
    {
        this.viewBlacklist = viewBlacklist;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/viewblacklist/viewblacklistresponse.tsx